<section class="header-card">
  <h1 *ngIf="headerText" class="header-card__header" data-cy="cardTitle">{{ headerText }}</h1>

  <main class="header-card__content" data-cy="cardContent">
    <ng-content> </ng-content>
  </main>
</section>
